export const oidc_issuer = process.env.OIDC_ISSUER || "id.wp-local.com";
export const oidc_client_id = process.env.OIDC_CLIENT_ID || "id.wp-local.com/user";
